import useSWR from 'swr'
import { APIDecoratorWithBaseURI } from '../../Service/api'
import { AxiosResponse } from 'axios'
import { useMemo } from 'react'

interface Tracker {
  facebook: string
  google: string
  google_ads: string
  tiktok: string
}

export interface TrackerResponse {
  tracker: Tracker
  trackerLoading: boolean
  trackerError: string | null
  trackerValidating: boolean
}

// type TrackerAxiosResponse = AxiosResponse<Tracker>

export const useGetTrackerIds = (id: string | number): TrackerResponse => {
  const url: string = `/analytics/tracker/getEventTrackerIds?eventId=${id}`

  const fetchData = async (): Promise<AxiosResponse> => {
    return await APIDecoratorWithBaseURI().get(url)
  }

  const { data, error, isLoading, isValidating } = useSWR<any>(url, fetchData)
  const nestedData = useMemo(() => data?.data?.data || {}, [data])

  const memoizedValue = useMemo(
    () => ({
      tracker: nestedData,
      trackerLoading: isLoading,
      trackerError: error,
      trackerValidating: isValidating,
    }),
    [nestedData, error, isLoading, isValidating]
  )

  return memoizedValue
}
